











































































































































































































import {
	computed,
	defineComponent,
	PropType,
	Ref,
	ref,
} from '@vue/composition-api';
import { v4 } from 'uuid';
import { bytesToSize } from '@front-app/util/bytesToSize';
import { Size, Spacing } from '@front-app/components/constants';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import TrForm from '@front-app/components/form/Form.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import { sum } from '@front-app/util/math';
import SimpleCard from '../cards/SimpleCard.vue';
import FileInput from '../inputs/FileInput.vue';
import CategoriesInput from '../inputs/CategoriesInput.vue';
import { FileData } from './FileModel';

export default defineComponent({
	components: {
		FontAwesomeIcon,
		CtaButton,
		TrCheckbox,
		TrForm,
		FormLabel,
		FormInput,
		FormSection,
		SimpleCard,
		CategoriesInput,
		FileInput,
	},
	props: {
		categories: {
			type: Array as PropType<string[]>,
			required: true,
		},
		selectedCategories: {
			type: Array as PropType<string[]>,
			required: true,
		},
		selectedNewCategories: {
			type: Array as PropType<string[]>,
			required: true,
		},
		maxUploadFileSize: {
			type: Number,
			default: Infinity,
		},
		remainingTotalFileBytes: {
			type: Number,
			default: Infinity,
		},
		notifyGroup: Boolean,
		canNotifyMembers: Boolean,
		canAddNewCategories: Boolean,
	},
	setup(props, ctx) {
		const withinMaxFileSize = (fileRequest: FileData) => fileRequest.file.size <= props.maxUploadFileSize;
		const files: Ref<FileData[]> = ref([]);
		const isDraggedOver = ref(false);
		const addFilesArr = (newFiles: File[]) => {
			const fileDatas = newFiles.map(fileToData);
			// Add new files with errors to the front
			const tooLargeFiles = fileDatas.filter((file) => !withinMaxFileSize(file));
			// Add new files without errors to the end
			const okFiles = fileDatas.filter((file) => withinMaxFileSize(file));
			files.value = tooLargeFiles.concat(files.value, okFiles);
			isDraggedOver.value = false;
		};
		const addFiles = (e: DragEvent) => {
			const newFiles = e.dataTransfer ? Array.from(e.dataTransfer.files) : [];
			addFilesArr(newFiles);
		};
		const removeFile = (targetId: string) => {
			files.value = files.value.filter(({ id }) => id !== targetId);
		};
		const getFileSize = (val: number) => {
			const fs = bytesToSize(val);
			const quantity = ctx.root.$n(fs.quantity, 'short');
			return ctx.root.$t(fs.size, { quantity });
		};
		const remainingTotalFileSize = computed(() => getFileSize(props.remainingTotalFileBytes));
		const uploadableFiles = computed(() => files.value.filter(withinMaxFileSize));
		const totalSize = computed(() => uploadableFiles.value.map(({ file }) => file.size)
			.reduce(sum, 0));
		const clearFiles = () => {
			files.value = [];
		};
		return {
			files,
			removeFile,
			clearFiles,
			addFiles,
			addFilesArr,
			isDraggedOver,
			withinMaxFileSize,
			remainingTotalFileSize,
			totalSize,
			getFileSize,
			uploadableFiles,
			// Constants
			ButtonPalettes,
			Size,
			Spacing,
		};
	},
});

function fileToData(newFile: File): FileData {
	return {
		id: v4(),
		file: newFile,
		fileName: newFile.name,
		description: '',
	};
}
